import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { InstagramBlock } from '../../other/instagramBlock';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter, FaLink } from 'react-icons/fa';
import { VLink } from '../../other/vLink';
import { Block } from '../../other/block';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';
import { Form } from '../form';

const EmailInput = styled.input`
  width: 100%;

  @media (min-width: 768px) {
    width: 350px;
  }
`;

const FooterWrapper = styled.div`
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding-left: 8px;
  padding-right: 8px;
  @media (min-width: 1080px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export interface FooterProps {
  link1Label: string;
  link2Label: string;
  link3Label: string;
  link4Label: string;
  link5Label: string;
  link1: string;
  link2: string;
  link3: string;
  link4: string;
  link5: string;
  recognition1label?: string;
  recognition2label?: string;
  recognition3label?: string;
  recognition4label?: string;
  recognition5label?: string;
  recognition1link?: string;
  recognition2link?: string;
  recognition3link?: string;
  recognition4link?: string;
  recognition5link?: string;
  companyEmailAddress?: string;
  twitterLink: string;
  facebookLink: string;
  instagramLink: string;
  linkedinLink: string;
  imageList: Asset[];
  logo: Asset;
  copyrightText: string;
  backgroundColour?: string;
  form: {
    heading: Document;
    formHtml: string;
  };
}

export const Footer: React.FC<FooterProps> = ({
  link1Label, link2Label, link3Label, link4Label, link5Label, link1, link2, link3, link4, link5,
  twitterLink, facebookLink, instagramLink, linkedinLink, imageList, logo, copyrightText, backgroundColour, form,
  recognition1label, recognition2label, recognition3label, recognition4label, recognition5label, recognition1link,
  recognition2link, recognition3link, recognition4link, recognition5link, companyEmailAddress,
}) => {
  return (
    <>
      {/*<InstagramBlock />*/}
      <footer className="text-white">
        <Block backgroundColour={backgroundColour} className="px-6" noSpacing={true}>
          <FooterWrapper>
            <div className="w-full mx-auto">
              <div className="flex flex-row justify-between">
                <div>
                  <img src={logo.url} alt={logo.name} className="h-12 md:h-16" />
                </div>
                <div>
                  <div className="text-xl md:text-3xl">
                    <VLink to={twitterLink} className="mr-4 hover:text-neon-green"  noFollow={true} newWindow={true}>
                      <FaTwitter className="inline" title={'Twitter'} />
                    </VLink>
                    {/*<VLink to={facebookLink} className="mr-4 hover:text-neon-green"  noFollow={true} newWindow={true}>*/}
                    {/*  <FaFacebookF className="inline" title={'Facebook'} />*/}
                    {/*</VLink>*/}
                    <VLink to={instagramLink} className="mr-4 hover:text-neon-green" noFollow={true} newWindow={true}>
                      <FaInstagram className="inline" title={'Instagram'} />
                    </VLink>
                    <VLink to={linkedinLink} className="mr-4 hover:text-neon-green"  noFollow={true} newWindow={true}>
                      <FaLinkedinIn className="inline" title={'LinkedIn'} />
                    </VLink>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full mx-auto mt-20 mb-5 sm:mb-16 ">
              <div className="flex flex-row flex-wrap justify-between">
                <div className="flex flex-row flex-wrap w-full -mx-6 xl:w-2/3 lg:flex-no-wrap xl:mb-0">
                  <div className="w-full px-6 mb-8 md:w-1/3">
                    <div className="mb-2 text-base uppercase">Contact</div>
                    <div>
                      Vervaunt,<br/>
                      145 City Rd WeWork<br />
                      London<br />
                      EC1V 1AZ
                    </div>
                    <div className="mt-5">
                      <a className="hover:text-neon-green" href={`mailto:${companyEmailAddress}`}>
                        {companyEmailAddress}
                      </a>
                    </div>
                  </div>
                  <div className="w-full px-6 mb-8 sm:w-1/2 md:w-2/5">
                    <div className="mb-2 text-base uppercase">Featured Links</div>
                    <div>
                      <VLink className="block mb-1 hover:text-neon-green" to={link1}>{link1Label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={link2}>{link2Label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={link3}>{link3Label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={link4}>{link4Label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={link5}>{link5Label}</VLink>
                      <a data-acsb-custom-trigger="true" className="block mb-1 cursor-pointer hover:text-neon-green">Accessibe</a>
                    </div>
                  </div>
                  <div className="invisible hidden w-full px-6 mb-8 sm:block md:w-1/3">
                    <div className="mb-2 text-base uppercase">Recognition</div>
                    <div>
                      <VLink className="block mb-1 hover:text-neon-green" to={recognition1link}>{recognition1label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={recognition2link}>{recognition2label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={recognition3link}>{recognition3label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={recognition4link}>{recognition4label}</VLink>
                      <VLink className="block mb-1 hover:text-neon-green" to={recognition5link}>{recognition5label}</VLink>
                    </div>
                  </div>
                </div>
                <div className="w-full xl:w-1/3">
                  <Form formHtml={form.formHtml} noSpacing={true} />
                </div>
              </div>
            </div>

            <div className="w-full mx-auto">
              <div className="text-sm">{copyrightText}</div>
            </div>
          </FooterWrapper>
        </Block>
      </footer>
    </>
  );
};
